import {
  ApiVersions,
  ConsumerTypes,
  IHostType,
  definePlatformAPI,
} from '../../common';
import { ISuperAPI } from './accessibility.super';

export type IPlatformAPIDefinition = {
  consumerType: typeof ConsumerTypes.Internal;
  version: typeof ApiVersions.V2;
  hostType: IHostType;
  superAPI: ISuperAPI;
  platformAPI: {
    accessibility: {
      getAdvancedSettings: () => Promise<boolean>;
      getSkipToContent: () => Promise<boolean>;
      getVisualFocus: () => Promise<boolean>;
      getAutoDomReorder: () => Promise<boolean>;
      setAdvancedSettings: (value: boolean) => Promise<void>;
      setSkipToContent: (enable: boolean) => Promise<void>;
      setVisualFocus: (enable: boolean) => Promise<void>;
      setAutoDomReorder: (enable: boolean) => Promise<void>;
    };
  };
};

export const platformAPICreator = definePlatformAPI<IPlatformAPIDefinition>(
  (superAPI) => {
    return (context) => {
      return {
        accessibility: {
          ...superAPI.accessibility,
          setAutoDomReorder: (enable) =>
            superAPI.accessibility.setAutoDomReorder(
              context.appDefinitionId,
              enable,
            ),
          setSkipToContent: (enable) =>
            superAPI.accessibility.setSkipToContent(
              context.appDefinitionId,
              enable,
            ),
          setVisualFocus: (enable) =>
            superAPI.accessibility.setVisualFocus(
              context.appDefinitionId,
              enable,
            ),
        },
      };
    };
  },
);
